module.exports = __webpack_public_path__ + "files/b6e98b1afece106bbb3f356b2c59e9ba.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-2.png
// module id = 1484
// module chunks = 60